import { render, staticRenderFns } from "./footerDown.vue?vue&type=template&id=1fbbe3f4&scoped=true&"
import script from "./footerDown.vue?vue&type=script&lang=js&"
export * from "./footerDown.vue?vue&type=script&lang=js&"
import style0 from "./footerDown.vue?vue&type=style&index=0&id=1fbbe3f4&lang=scss&scoped=true&"
import style1 from "./footerDown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbbe3f4",
  null
  
)

export default component.exports